import {
  Box,
  Container,
  Flex,
  Stack,
  Text,
  HStack,
  Link,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import t from "../translations";

export default function Footer({ color }) {
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const textColor = useColorModeValue("gray.500", "gray.400");

  return (
    <Box
      bg={useColorModeValue("gray.50", "gray.900")}
      borderTop="1px solid"
      borderColor={borderColor}
    >
      <Container as={Stack} maxW="6xl" py={6}>
        <Stack
          direction={{ base: "column", md: "row" }}
          align="center"
          spacing={4}
        >
          <Flex flex="1" justify={{ base: "center", md: "flex-start" }}>
            <Text fontSize="sm" color={textColor}>
              &copy; {new Date().getFullYear()} {t.footer.copyright}
            </Text>
          </Flex>
          <Flex flex="1" justify="center">
            <Text fontSize="xs" color={textColor}>
              {t.footer.builtWith}
            </Text>
          </Flex>
          <Flex flex="1" justify={{ base: "center", md: "flex-end" }}>
            <HStack spacing={4}>
              <Link
                href={t.profile.linkedin}
                isExternal
                aria-label="LinkedIn"
                color={textColor}
                _hover={{ color: `${color}.400` }}
                transition="color 0.2s"
              >
                <FaLinkedin size={18} />
              </Link>
              <Link
                href={t.profile.github}
                isExternal
                aria-label="GitHub"
                color={textColor}
                _hover={{ color: `${color}.400` }}
                transition="color 0.2s"
              >
                <FaGithub size={18} />
              </Link>
            </HStack>
          </Flex>
        </Stack>
      </Container>
    </Box>
  );
}
